import reducer from "./reducer";
export { default as FeedbackPurpose } from "./components/index";
export { default as feedbackPurposeReducerName } from "./constants";
export default reducer;
